import { environment } from 'src/environments/environment';
import { BlocksApp } from '../blocks-app';
import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';
import { GameMainScene } from 'src/games/common/phaser/game/scenes/game-main-scene';

export class BlocksMainScene extends GameMainScene {
  public static get className(): string {
    return BlocksMainScene.name;
  }

  constructor() {
    super({ key: BlocksMainScene.className, active: false });
  }

  public override showStartButton(showButton: boolean): void {
    BlocksApp.getInstance().gameController.showStartButton(showButton);
  }

  public override startRound(moves: string[], _logicVersion: number): void {
    BlocksApp.getInstance().gameController.startRemoteRound(moves);
  }

  public override setInstantFinish(): void {
    BlocksApp.getInstance().gameController.setInstantFinish();
  }

  public override autoStartGame(): void {
    BlocksApp.getInstance().gameController.autoStartGame();
  }

  public override resetGameScene(): void {
    BlocksApp.getInstance().gameController.resetGameScene();
  }

  protected override initGraphics() {
    super.initGraphics();

    if (!environment.production) {
      //this.createDebugHelpers();
    }

    BlocksApp.getInstance().gameController.initGraphics(this);
  }

  protected override onResize(gameSizeMetrics: GameSizeMetrics): void {
    BlocksApp.getInstance().gameController.onResize(gameSizeMetrics);
  }

  protected override onSceneReady(key: string) {
    super.onSceneReady(key);

    if (key === BlocksMainScene.className) {
      BlocksApp.getInstance().gameController.onSceneReady();
    }
  }

  private createDebugHelpers() {
    this.time.addEvent({
      delay: 2500,
      loop: true,
      callback: () => {
        console.info('Display List:');
        console.table(this.sys.displayList.list, ['name', 'type', 'x', 'y', 'active']);
      },
    });
  }
}
